import { FilePresent, InsertDriveFile } from '@mui/icons-material';
import { Stack } from '@mui/material';
import { GenButton } from '@pinnacleautomotive/clarity-components';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { EndPoints, StatusCode } from '../../../common/enums/enums';
import { amplifyApi } from '../../../hooks/amplifyApi';
import {
  selectUserCompaniesWithContracts,
  selectUserPerson,
} from '../../../redux/selectors/userDataSelectors';

const handleSelectedGroupedDate = (selectedDate, type) => {
  const arr = [];
  arr.push({
    column: type,
    value: selectedDate.startingDate,
    operator: 'gte',
  });
  arr.push({
    column: type,
    value: selectedDate.endDate,
    operator: 'lte',
  });
  return arr;
};

const handleSelectedGroupedSteps = selectedSteps => ({
  OR: selectedSteps.map(s => ({
    column: 'step',
    value: s,
    operator: 'eq',
  })),
});

const handleSelectedGroupedDealers = selectedDealers => ({
  OR: selectedDealers.map(d => ({
    column: 'companyId',
    value: d,
    operator: 'eq',
  })),
});
const handleGenerateGroupedFilter = (filters, companiesIds) => {
  const groupedFilters = {
    AND: [{ AND: [] }],
  };
  groupedFilters.AND[0].AND.push(
    ...handleSelectedGroupedDate(filters.selectedDate, filters.dateFormat)
  );
  if (
    filters.selectedDealers.dealers.length &&
    !filters.selectedDealers.allSelected
  ) {
    groupedFilters.AND.push(
      handleSelectedGroupedDealers(filters.selectedDealers.dealers)
    );
  } else {
    groupedFilters.AND.push(handleSelectedGroupedDealers(companiesIds));
  }
  if (filters.selectedSteps.steps.length && !filters.selectedSteps.allSelected)
    groupedFilters.AND.push(
      handleSelectedGroupedSteps(filters.selectedSteps.steps)
    );
  if (filters.excludeWo)
    groupedFilters.AND[0].AND.push({
      column: 'amount',
      operator: 'ne',
      value: 0,
    });
  return groupedFilters;
};

const ExportBulkButtons = ({ selectedFilters, setShowSnackbar, dateError }) => {
  const { t } = useTranslation('bulk');
  const person = useSelector(selectUserPerson);
  const companiesIds = useSelector(selectUserCompaniesWithContracts).map(
    c => c.companyId
  );
  const [isLoading, setIsLoading] = useState(null);

  const handleBulKExport = (filters, user, type) => {
    setIsLoading(type);
    amplifyApi(
      {
        personName: `${user.firstName} ${user.lastName}`,
        recipient: user.email,
        orderBy: filters.dateFormat,
        order: 'desc',
        groupedFilters: handleGenerateGroupedFilter(filters, companiesIds),
        ...(!filters.selectedServices.allSelected &&
          filters.selectedServices.services.length && {
            serviceFilter: {
              include: true,
              services: filters.selectedServices.services,
            },
          }),
        ...(!filters.selectedDepartments.allSelected &&
          filters.selectedDepartments.departments.length && {
            departmentFilter: {
              include: true,
              departments: filters.selectedDepartments.departments,
            },
          }),
      },
      ...(type === 'PDF'
        ? EndPoints.BULK_EXPORT.BULK_PDF
        : EndPoints.BULK_EXPORT.BULK_CSV),
      true
    )
      .then(response => {
        if (response.status === StatusCode.SUCCESS)
          setShowSnackbar({
            open: true,
            text: 'successSnackBar',
            type: 'success',
          });
        setIsLoading(null);
      })
      .catch(error => {
        setShowSnackbar({
          open: true,
          text: 'errorSnackbar',
          type: 'error',
        });
        setIsLoading(null);
      });
  };

  return (
    <Stack direction="row" gap={1}>
      <GenButton
        text={t('generatePdf')}
        startIcon={<InsertDriveFile />}
        variant="outlined"
        size="medium"
        onClick={() => handleBulKExport(selectedFilters, person, 'PDF')}
        loading={isLoading === 'PDF'}
        disabled={dateError}
      />
      <GenButton
        text={t('generateCsv')}
        startIcon={<FilePresent />}
        variant="contained"
        size="medium"
        onClick={() => handleBulKExport(selectedFilters, person, 'CSV')}
        loading={isLoading === 'CSV'}
        disabled={dateError}
      />
    </Stack>
  );
};

export default ExportBulkButtons;
